<template>
  <v-container>
    <AppLoadingSpinner v-model="isLoading" />
    <v-alert
      type="success"
      dense
      transition="slide-y-transition"
      :value="isUpdateSuccess"
      >更新成功！</v-alert
    >
    <v-row>
      <v-col cols="11">
        <v-form ref="form">
          <v-card flat max-width="600px">
            <v-card-title>用户信息</v-card-title>
            <v-card-text class="ml-4">
              <v-text-field
                filled
                dense
                label="用户机构显示名称"
                v-model="userName"
                :rules="fieldRules.userName"
              ></v-text-field>
              <v-textarea
                filled
                dense
                label="用户机构描述"
                v-model="userDesc"
                rows="1"
                auto-grow
                :rules="fieldRules.userDesc"
              ></v-textarea>
            </v-card-text>
            <v-card-title v-if="isSingletonCustomer">登录页显示</v-card-title>
            <v-card-text v-if="isSingletonCustomer" class="ml-4">
              <v-text-field
                filled
                dense
                label="登录页面的显示标题"
                v-model="landingTitle"
                :rules="fieldRules.landingTitle"
              ></v-text-field>
            </v-card-text>
            <!--
            <v-card-title>二维码设置</v-card-title>
            <v-card-text class="ml-4">
              <div class="d-flex align-center">
                <v-file-input
                  class="mr-4"
                  v-model="uploadImage"
                  label="点击添加二维码中心的图标"
                  prepend-icon="mdi-file-image-outline"
                  accept="image/*"
                  :error="!!uploadErrorMsg"
                  :error-messages="uploadErrorMsg"
                  :rules="fieldRules.uploadImage"
                ></v-file-input>
                <v-btn color="primary" @click="uploadCustomerPortrait">
                  上传
                </v-btn>
              </div>
              <div class="mt-4" v-if="!!portrait">
                <div>已上传的图标</div>
                <img :src="portrait" />
              </div>
            </v-card-text> -->
            <v-card-actions class="ml-4 my-6">
              <v-btn
                color="primary"
                depressed
                @click="saveUserCustInfo"
                :disabled="isBtnLoading"
                :loading="isBtnLoading"
                >确认修改</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
    </v-row>
    <AppMessageBox v-model="errorMsg" title="发生错误" />
  </v-container>
</template>

<script>
import AppLoadingSpinner from "@/components/AppLoadingSpinner";
import AppMessageBox from "@/components/AppMessageBox";
import { mapGetters, mapActions } from "vuex";
import {
  fetchUserCustInfo,
  saveUserCustInfo,
  uploadUserPortrait
} from "@/api/user";

export default {
  components: {
    AppLoadingSpinner,
    AppMessageBox
  },

  data() {
    return {
      userName: "",
      userDesc: "",
      landingTitle: "",
      portrait: "",
      uploadImage: null,
      isSingletonCustomer: false,
      fieldRules: {
        userName: [
          val => (val || "").length > 0 || "机构显示名称不能为空",
          val => (val || "").length <= 50 || "机构显示名称不能超过50个字符"
        ],
        userDesc: [
          val => (val || "").length < 1000 || "机构描述不能超过1000个字符"
        ],
        landingTitle: [
          val => (val || "").length <= 50 || "登录页的显示标题不能超过50个字符"
        ],
        uploadImage: [
          val =>
            !val || !val.size || val.size < 10240 || "上传的图片不能超过10KB"
        ]
      },
      isUpdateSuccess: false,
      errorMsg: "",
      uploadErrorMsg: "",
      isLoading: false,
      isBtnLoading: false
    };
  },

  computed: {
    ...mapGetters({
      regionGuid: "user/regionGuid"
    })
  },

  methods: {
    ...mapActions({
      setUserDispName: "user/setUserDispName"
    }),
    showSuccessMsg() {
      this.isUpdateSuccess = true;
      setTimeout(() => (this.isUpdateSuccess = false), 2000);
    },
    async reloadUserCustInfo() {
      try {
        this.isLoading = true;
        let userCustInfo = await fetchUserCustInfo(this.regionGuid);
        this.userName = userCustInfo.displayName;
        this.userDesc = userCustInfo.description;
        this.landingTitle = userCustInfo.landingTitle;
        this.isSingletonCustomer = userCustInfo.isSingleton;
        this.portrait = userCustInfo.portrait;
      } catch (err) {
        this.errorMsg = err.message;
      }
      this.isLoading = false;
    },
    async saveUserCustInfo() {
      let isValid = this.$refs.form.validate();
      if (isValid) {
        try {
          this.isBtnLoading = true;
          await saveUserCustInfo(this.regionGuid, {
            userName: this.userName,
            userDesc: this.userDesc,
            landingTitle: this.landingTitle
          });
          this.setUserDispName(this.userName);
          this.showSuccessMsg();
        } catch (err) {
          this.errorMsg = err.message;
        }
        this.isBtnLoading = false;
      }
    },
    async uploadCustomerPortrait() {
      let isValid = this.$refs.form.validate();
      if (isValid) {
        try {
          this.isLoading = true;
          await uploadUserPortrait(this.regionGuid, this.uploadImage);
          // 刷新页面
          await this.reloadUserCustInfo();
          this.uploadImage = null;
          this.$refs.form.resetValidation();
        } catch (err) {
          this.uploadErrorMsg = err.message;
        }
        this.isLoading = false;
      }
    }
  },

  created() {
    this.reloadUserCustInfo();
  }
};
</script>
